import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {ProviderLogo} from '../ProviderLogo'

export const ReviewSource = ({providerCode}: {providerCode: string}) => {
  return (
    <Box display="flex" gap="s200">
      <Text variant="bodyXS" colorPath="content.neutral.secondary">
        <FormattedMessageWrapper id="via" defaultMessage="via" />
      </Text>
      <ProviderLogo providerCode={providerCode} height={16} />
    </Box>
  )
}
